module.exports = __webpack_public_path__ + "static/img/led_difuso_azul_3mm-1.ad25ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_azul_3mm-1.svg
// module id = o5AU
// module chunks = 0